module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921064149_T.de2b7a3f.jpg";